// ============================================================================
// AVAILABILITY COLOUR SCALE — shared
// ============================================================================
// One definition for both the Availability Calendar (TXN-AVAIL-001) and the
// Booking Worksheet's free-inventory strip. Two copies of this scale would let
// the same night read "healthy" on one screen and "critical" on the other.
//
// The scale is keyed on AVAILABILITY, not occupancy: green = plenty free.
// That reads as "there is stock to sell here" — which is what the worksheet
// strip is for — and it means green means the same thing on both screens.
// See crs-doc/CRS-Booking-Worksheet-Day-View-Design.md decision 2.

/**
 * Oversold nights read differently from sold-out ones and must LOOK different.
 * Both show "0 available" — `available_rooms` is clamped at zero so nothing can be
 * sold against an oversell — so without a distinct treatment a night the property
 * has to actively manage is indistinguishable from a night that simply sold well.
 * See crs-doc/CRS-Inventory-Shortage-and-Oversell-Design.md §9.
 */
export const getAvailColor = (available: number, total: number, oversold = 0): string => {
  if (oversold > 0) return 'var(--danger, #dc2626)';
  if (total === 0) return 'var(--text-muted)';
  const pct = (available / total) * 100;
  if (pct > 50) return 'var(--success, #16a34a)';
  if (pct > 20) return 'var(--warning, #d97706)';
  if (pct > 0) return 'var(--danger, #dc2626)';
  return 'var(--text-muted)';
};

export const getAvailBg = (available: number, total: number, oversold = 0): string => {
  if (oversold > 0) return 'rgba(220, 38, 38, 0.42)';   // deeper than any sold-out cell
  if (total === 0) return 'transparent';
  const pct = (available / total) * 100;
  if (pct > 50) return 'rgba(22, 163, 74, 0.18)';
  if (pct > 20) return 'rgba(217, 119, 6, 0.18)';
  if (pct > 0) return 'rgba(220, 38, 38, 0.18)';
  return 'rgba(0, 0, 0, 0.08)';
};
